import { Col, Collapse, Row } from "antd";
import React from "react";
import AppContentFieldItem3 from "./app_content_field3";
import "./app_quotation_detail_card.css";
import TermsAndConditionDialog from "../terms_and_condition_dialog/terms_and_condition_dialog";
import LanguageBloc from "../../../bloc/language_bloc";
// import Labels from "../../constant/labels";
import DocumentBloc from "../../../bloc/document_bloc";
import App_loading_dialog from "../../dialog/app_loading_dialog";
import UtilBloc from "../../../bloc/util_bloc";
import { ReactComponent as ArrowDownIcon } from "../../../ArrowDownIcon.svg";
import { ReactComponent as ChevronRightIcon } from "../../../ChevronRight2.svg";
import PDFViewer from "../pdf/mrtt_pdf_viewer";

const { Panel } = Collapse;

class AppUploadedDocumentsDetailsCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data,
    };
  }

  stateData() {
    return this.state.data;
  }

  componentDidMount() { }

  openViewDialog(type, content, filename) {
    this.setState({
      isOpenPDF: true,
      type: type,
      pdfContent: content,
      pdfName: filename,
    });
  }

  closeViewDialog() {
    this.setState({
      isOpenPDF: false,
      loading: false,
    });
  }

  downloadPDF() {
    let pdfObject = this.state.field;
    let base64Value = this.state.pdfContent;
    let fileName = pdfObject.caption;
    UtilBloc.b64toBlob(base64Value, "application/pdf", fileName, "download");
  }

  printPDF() {
    let pdfObject = this.state.field;
    let base64Value = this.state.pdfContent;
    let fileName = pdfObject.caption;
    UtilBloc.b64toBlob(base64Value, "application/pdf", fileName, "print");
  }

  renderField(field) {
    if (!field) {
      return <div />;
    }

    return (
      <AppContentFieldItem3
        title={field.caption || field.filename}
        value={
          field.value == "" || field.value == 0.0 || field.value == null
            ? "-"
            : field.value
        }
        size={Number(field.size).toFixed(2)}
        type={field.type}
        onView={(id) => {
          // Add view action here
        //   this.setState({
        //     field,
        //   });
          this.openViewDialog(field.type, field.content, field.filename);
        }}
        onDelete={(id) => { }}
      />
    );
  }

  renderRow(item1) {
    return (
      <Row>
        <Col >{item1}</Col>
      </Row>
    );
  }

  loadingContent() {
    return (
      <div style={{ height: "100%", width: "100%" }}>
        <App_loading_dialog isLoading={this.state.loading} />
      </div>
    );
  }

  renderFieldsFromObject() {
    return (
      <>
        <div>{this.state.loading && this.loadingContent()}</div>
        <PDFViewer
          open={this.state.isOpenPDF}
          title={this.state.pdfName}
          handleModalClose={() => this.closeViewDialog()}
          width={'70%'}
          content={this.state.pdfContent}
          closable={false}
          showDownload={true}
          document={this.state.type}
        />
        {/* <TermsAndConditionDialog
          showClose={true}
          showDownload={true}
          downloadPDF={() => {
            this.downloadPDF();
          }}
          printPDF={() => {
            this.printPDF();
          }}
          isOpen={this.state.isOpenPDF}
          content={this.state.pdfContent || null}
          onDialogClose={(e) => this.closeViewDialog()}
          type={this.state.type}
          showPositiveButton={this.props.showPositiveButton}
        /> */}
        {this.stateData() &&
          this.stateData().data.map((field) => {
            return (
              <div key={field}>{this.renderRow(this.renderField(field))}</div>
            );
          })}
      </>
    );
  }

  render() {
    return (
      <div className="collapse_container mt-3 d-flex align-items-center">
        <Collapse
          className="p-1 d-flex align-items-center justify-items-center"
          bordered={false}
          style={{
            backgroundColor: "white",
          }}
          defaultActiveKey={[0]}
          expandIcon={(isActive) =>
            isActive.isActive ? <ArrowDownIcon className="collapse_icon" />
              : <ChevronRightIcon className="collapse_icon" />
          }
        >
          <Panel
            key={1}
            header={this.props.title || 'Generated Documents'}
            className="collapse_title"
          >
            {this.renderFieldsFromObject()}
          </Panel>
        </Collapse>
      </div>

    );
  }
}

export default AppUploadedDocumentsDetailsCard;
